<footer class="footer" *transloco="let t; read: 'db-footer'">
  <div class="footer-content">
    <div class="copyright font-normal-regular">
      <img src="assets/images/accredible-new-logo.svg" alt="Accredible" />
      {{ t('copyright', { year: currentYear }) }}
    </div>
    <ul class="links">
      <span class="separator">•</span>
      <li>
        <a class="font-normal-regular" href="https://www.accredible.com/terms/" target="_blank">{{
          t('links.terms')
        }}</a>
      </li>
      <span class="separator">•</span>
      <li>
        <a
          class="font-normal-regular"
          href="https://www.accredible.com/data-privacy/"
          target="_blank"
          >{{ t('links.privacy') }}</a
        >
      </li>
      <span class="separator">•</span>
      <li>
        <a class="font-normal-regular" href="https://help.accredible.com/s/" target="_blank">{{
          t('links.help')
        }}</a>
      </li>
    </ul>
  </div>
</footer>
